"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NonClosableMenuItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _compoundComponents = require("@clds/compound-components");
var _menu = require("@clds/menu");
var _DropdownMenuContext = require("./DropdownMenuContext");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const useRegisterNonClosableMenuItem = id => {
  const {
    registerNonClosableMenuItem,
    unregisterNonClosableMenuItem
  } = (0, _DropdownMenuContext.useDropdownMenuContext)();
  (0, _react.useLayoutEffect)(() => {
    registerNonClosableMenuItem(id);
    return () => unregisterNonClosableMenuItem(id);
  }, [id, registerNonClosableMenuItem, unregisterNonClosableMenuItem]);
};
const NonClosableMenuItem = ({
  id: idProvided,
  ...rest
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const id = (0, _compoundComponents.useUniqueId)(idProvided);
  useRegisterNonClosableMenuItem(id);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  return /*#__PURE__*/_react.default.createElement(_menu.MenuItem, _extends({
    id: id
  }, rest));
};
exports.NonClosableMenuItem = NonClosableMenuItem;
//# sourceMappingURL=NonClosableMenuItem.js.map